<template>
  <option-list :options="options" :entity-type="EntityType.STAGE" :entity-id="$route.params.stageId.toString()" />
</template>

<script>
import { mapState } from 'vuex';

import OptionList from '@/components/formComponents/options/OptionList';
import { EntityType } from '@/enums/entityType.enum';
import { wizardStepMixin } from '@/mixins/wizardStep';

// @vuese
// Edycja opcji etapu
// @group Stage
export default {
  components: { OptionList },
  data() {
    return {
      EntityType
    };
  },
  computed: mapState({
    options: state => state.option.list
  })
};
</script>
